<div class="newsfeedview-container">
  <div class="back">
    <span><a (click)="goBack()" class="back-link">Back</a></span>
  </div>

  <mat-card class="newsfeedview-content">
    <div class="card-contents">
      <mat-card-header *ngIf="onenewsfeed">
        <mat-card-title>
          <h1>{{onenewsfeed.Title}}</h1>
        </mat-card-title>
        <mat-card-subtitle>
          <h2>{{onenewsfeed.Headline}}</h2>
        </mat-card-subtitle>
        <mat-card-subtitle id="date">{{onenewsfeed.CreatedDate}}</mat-card-subtitle>
      </mat-card-header>
      <div class="content">
        <mat-card-content *ngIf="onenewsfeed">
          <!-- <div [innerHTML]="onenewsfeed.NewsfeedContent | sanitizeHtml"></div> -->
          <div class="ql-container ql-snow" style="border-width: 0;">
            <div class="ql-editor" [innerHTML]="onenewsfeed.NewsfeedContent"> <!-- | santizieHtml"> -->
            </div>
          </div>
        </mat-card-content>
      </div>
      <!-- <mat-card-actions>
          <button  mat-button>LIKE</button>
          <button mat-button>SHARE</button>
      </mat-card-actions> -->
    </div>
  </mat-card>

</div>
